import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useRef,
  useMemo,
} from "react";

import api from "../helpers/api.js";

import axios from "axios";

import Config, { token } from "../config.js";

import "./styles/chat-context.css";

import { useAuth } from "./AuthContext.js";
import { useChallenge } from "./ChallengeContext.js";

import * as Mui from "@mui/material";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";

import { ReactComponent as ExcelIcon } from "../assets/custom-icons/excel.svg";
import { ReactComponent as PDFIcon } from "../assets/custom-icons/pdf.svg";

import InfiniteScroll from "react-infinite-scroll-component";

import UsersSelectionModal from "../components/UsersSelectionModal";

const ChatContext = createContext();

export default function ChatsBox({ children }) {
  const [loading, setLoading] = useState(true);

  const [chats, setChats] = useState([]);
  const [preview, setPreview] = useState();
  const [currentChat, setCurrentChat] = useState();

  const [selectUsersModalOpen, setSelectUsersModalOpen] = useState(false);

  const { currentChallenge } = useChallenge();

  const { user } = useAuth();

  const REF_lastChatsUpdate = useRef(Date.now());
  const REF_chatsUpdateSet = useRef(false);

  useEffect(() => {
    if (loading) {
      loadChats();
    }
  }, [loading]);

  useEffect(() => {
    if (REF_chatsUpdateSet.current) return;
    const interval = setInterval(() => {
      try {
        const now = Date.now();
        const updateTimeout = 30000;

        if (now - REF_lastChatsUpdate.current >= updateTimeout) {
          setLoading(true);
          REF_lastChatsUpdate.current = now;
        }
      } catch (e) {
        console.log(e);
      }
    }, 1000);
    REF_chatsUpdateSet.current = true;

    return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
  }, []);

  useEffect(() => {
    const chatEventHandler = (e) => {
      startChatWith(e.detail);
    };
    window.addEventListener("start_chat_with", chatEventHandler);

    return () => {
      window.removeEventListener("start_chat_with", chatEventHandler);
    };
  }, []);

  function startChatWith(chatInfo) {
    setCurrentChat({ ...chatInfo });
  }

  async function loadChats() {
    setLoading(true);

    try {
      const { data } = await api.get("chats");
      if (JSON.stringify(data) !== JSON.stringify(chats)) setChats([...data]);
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  function handleOpenPreview(imageUrl) {
    setPreview(imageUrl);
  }

  async function handleSearchUsers(v) {
    console.log("Value", v);
    try {
      const { data } = await api.get(
        "/challenge/members?challenge_id=" +
          currentChallenge?.challenge_id +
          "&search_string=" +
          v.trim()
      );
    } catch (e) {
      console.log(e);
    }
  }

  const Memo_ChatList = useMemo(
    () => (
      <>
        {user && (
          <ChatList
            chats={chats}
            startChatWith={startChatWith}
            onSearchInputFocus={() => setSelectUsersModalOpen(true)}
          />
        )}
      </>
    ),
    [user, chats]
  );
  const Memo_Chat = useMemo(
    () => (
      <>
        {currentChat && (
          <CurrentChat
            handleOpenPreview={handleOpenPreview}
            info={currentChat}
            onClose={() => setCurrentChat(null)}
          />
        )}
      </>
    ),
    [currentChat]
  );

  return (
    <>
      {Memo_ChatList}
      {Memo_Chat}

      {preview && <Preview image={preview} onClose={() => setPreview(null)} />}
      <UsersSelectionModal
        mainButtonText={"Enviar treino"}
        open={selectUsersModalOpen}
        title="Enviar mensagem para participante"
        allowMultipleSelection={false}
        onClose={() => setSelectUsersModalOpen(false)}
        onSubmit={(usersSelected) => {
          console.log(usersSelected);
        }}
        onSelect={(user) => {
          user.user_id = user.id;
          startChatWith(user);
          setSelectUsersModalOpen(false);
        }}
        hideFooter={true}
      />
    </>
  );
}

function sendMessageTo(userInfo) {
  userInfo.user_id = userInfo.id;
  userInfo.id = undefined; //Removido, pois o id no chat significa o id do chat, não do userId
  const event = new CustomEvent("start_chat_with", { detail: userInfo });
  window.dispatchEvent(event);
}

export { sendMessageTo };

function Preview({ image, onClose }) {
  return (
    <div className="preview-area">
      <img src={image} className="preview-img" />
      <div className="overlay-close" onClick={onClose}></div>
      <Mui.IconButton onClick={onClose} className="close-icon">
        <CloseIcon color="white" />
      </Mui.IconButton>
    </div>
  );
}

function CurrentChat({ info, handleOpenPreview, onClose }) {
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);

  const { user } = useAuth();

  const [file, setFile] = useState();

  const REF_messagesBox = useRef();
  const REF_socket = useRef();
  const REF_newMessageInput = useRef();

  console.log("Info", info);

  useEffect(() => {
    if (loading) handleLoadMessages();
  }, [loading]);

  useEffect(() => {
    setLoading(true);

    return () => {
      if (REF_socket.current) {
        REF_socket.current.close();
        REF_socket.current = null;
      }
    };
  }, [info]);

  async function getChatId() {
    try {
      const { data } = await api.get(
        "chats/retriveChatWithUser?user_id=" + info.user_id
      );
      return data;
    } catch (e) {
      console.log("Error loading messages", e);
    }
  }

  async function handleLoadMessages(bypassReconnect = false) {
    REF_socket.current = null;

    try {
      const { data } = await api.get("chats/history?userId=" + info.user_id);
      console.log("Messages", data);
      if (!bypassReconnect) {
        handleConnectToChat();
        registerView();
      }
      setMessages([...data.messages.reverse()]);
      setTimeout(() => scrollToBottom(!bypassReconnect), 10);
    } catch (e) {
      console.log("Error loading messages", e);
    }

    setLoading(false);
  }
  async function handleSendMessage(e) {
    e?.preventDefault();
    console.log("Submit");

    const value = REF_newMessageInput.current?.value.trim();

    try {
      const payload = {
        text: value,
        receiver_id: info.user_id,
      };

      if (!!file && !!file?.data) {
        payload.asset = {
          data: file.data,
          type: file.type,
          contentInfo: {
            fileName: file.fileName,
          },
        };

        payload.asset.data = payload.asset.data.split(",")[1];

        if (file.type === "IMAGE") {
          payload.asset.contentInfo.imageAspectRatio = file.aspectRatio;
        }
      }

      const { data } = await api.post("chats/message", payload);

      console.log("MESSAGE RES", data);

      setFile(null);

      if (data.success) {
        handleLoadMessages(true);
      }
    } catch (e) {
      console.log(e);
    }

    REF_newMessageInput.current.value = "";
    REF_newMessageInput.current.focus();

    console.log(value);
  }
  async function registerView() {
    try {
      const { data } = await api.post("chats/message/registerView", {
        sender_id: info.user_id,
      });
    } catch (e) {}
  }

  function scrollToBottom(smooth = true) {
    /* console.log(REF_messagesBox.current?.scrollHeight);
    REF_messagesBox.current?.scrollTo({
      top: REF_messagesBox.current?.scrollHeight,
      behavior: smooth ? "smooth" : "instant",
    });*/
  }

  async function handleConnectToChat() {
    const endpoint = Config.wsEndpoint;
    const chatId = info.id ? info.id : await getChatId();
    const channel = "chat." + chatId;

    const ws = new WebSocket(endpoint);

    ws.onopen = () => {
      if (REF_socket.current) {
        REF_socket.current.close();
      }
      REF_socket.current = ws;
      console.log("Conectado a", channel);
      ws.send(
        JSON.stringify({
          event: "pusher:subscribe",
          data: {
            channel: channel,
          },
        })
      );
    };

    ws.onmessage = (e) => {
      const data = JSON.parse(e.data);
      if (data && data.event === "MessageSent") {
        if (data.channel !== channel) return;

        const messageInfo = JSON.parse(data.data).message;
        messageInfo.content = JSON.parse(messageInfo.content);
        messageInfo.created_at = new Date(messageInfo.created_at)
          .toISOString()
          .replace("T", " ")
          .split(".")[0];

        if (messageInfo.sender_id === user.id) return;

        console.log("New message", data.channel, data);

        registerView();

        setMessages((prev) => [...prev, messageInfo]);
        setTimeout(() => scrollToBottom(false), 100);
      }
    };

    ws.onclose = () => {
      console.log("Conexão finalizada: ", channel);
      REF_socket.current = null;
    };

    ws.onerror = (e) => {
      console.log("Erro no websocket", e);
    };
  }

  const fileInputRef = useRef(null);

  const handleAddFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const maxSizeInBytes = 50 * 1024 * 1024; // 50 MB
        if (file.size > maxSizeInBytes) {
          alert("O tamanho do arquivo excede 50 MB.");
          return;
        }

        const fileType = getFileType(file.type);

        if (fileType === "UNSUPPORTED") {
          alert("Arquivo não suportado");
          return false;
        }

        const fileUpload = {
          fileName: file.name,
          type: fileType,
        };

        switch (fileType) {
          case "IMAGE":
            const res = await resizeImage(file, 720);
            fileUpload.data = res.base64;
            fileUpload.aspectRatio = res.aspectRatio || 1;
            break;
          case "PDF":
          case "XLSX":
            fileUpload.data = await convertFileToBase64(file);
            break;
          default:
            console.log("Unsupported file type");
        }

        console.log(fileUpload);

        setFile({ ...fileUpload });
      } catch (e) {
        console.log("Error importing file", e);
      }
    }

    function getFileType(mimeType) {
      if (mimeType.startsWith("image/")) {
        return "IMAGE";
      } else if (mimeType === "application/pdf") {
        return "PDF";
      } else if (
        mimeType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        return "XLSX";
      } else {
        return "UNSUPPORTED";
      }
    }

    function resizeImage(file, maxWidth) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const aspectRatio = img.width / img.height;
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const scaleFactor = maxWidth / img.width;
            canvas.width = maxWidth;
            canvas.height = img.height * scaleFactor;
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob) => {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
              });
              convertFileToBase64(resizedFile)
                .then((base64) => resolve({ base64, aspectRatio }))
                .catch(reject);
            }, file.type);
          };
          img.src = event.target.result;
        };
        reader.readAsDataURL(file);
      });
    }

    function convertFileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }
  };

  function ChatHeader() {
    return (
      <div className="px-2 chat-header">
        <div>
          <Mui.Badge
            color="success"
            variant="dot"
            overlap="circular"
            badgeContent=" "
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            className="online-badge"
          >
            <img src={info.avatar} className="user-avatar" />
          </Mui.Badge>
        </div>
        <h5>
          <a
            className="anchor"
            href="#"
            onClick={() => {
              window.openUserDetails(info.user_id);
            }}
          >
            {info.username || info.email}
          </a>
        </h5>
        <Mui.IconButton
          size="small"
          onClick={() => {
            onClose();
            if (REF_socket.current) {
              REF_socket.current.close();
              REF_socket.current = null;
            }
          }}
        >
          <CloseIcon size="small" />
        </Mui.IconButton>
      </div>
    );
  }

  function MessagesBox() {
    function Loading() {
      return (
        <div className="mt-3 messages-loading-row">
          <Mui.Skeleton
            variant="rectangular"
            width={180}
            height={24}
            className="mt-1 message-loading"
          />
          <Mui.Skeleton
            variant="rectangular"
            width={210}
            height={24}
            className="mt-1 message-loading"
          />
          <Mui.Skeleton
            variant="rectangular"
            width={80}
            height={24}
            className="mt-1 message-loading"
          />
        </div>
      );
    }

    return (
      <div
        className="messages-box px-2 py-3"
        id="scrollableDiv"
        ref={REF_messagesBox}
        style={{
          height: 300,
          overflow: "auto",
          display: "flex",
          flexDirection: "column-reverse",
        }}
      >
        {!loading ? (
          <InfiniteScroll
            dataLength={messages.length}
            inverse={true}
            scrollableTarget="scrollableDiv"
          >
            {messages?.map((item, k) => (
              <Message
                data={item}
                key={item.id}
                info={info}
                handleOpenPreview={handleOpenPreview}
              />
            ))}
          </InfiniteScroll>
        ) : (
          ["", "", "", "", "", "", "", "", ""].map((_, i) => (
            <Loading key={i} />
          ))
        )}
      </div>
    );
  }

  function Footer() {
    return (
      <form className="chat-footer px-2 py-1" onSubmit={handleSendMessage}>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        <Mui.IconButton
          onClick={handleAddFile}
          type="button"
          className="append-file-button"
          size="small"
        >
          <AttachFileIcon color="primary" size="small" />
        </Mui.IconButton>
        <Mui.TextField
          inputRef={REF_newMessageInput}
          fullWidth
          placeholder={
            "Digite uma mensagem para " +
            (info.username?.split(" ")[0] || info.email)
          }
          id="fullWidth"
          size="small"
          autoFocus
        />
        <Mui.IconButton type="submit" className="submit-chat" size="medium">
          <SendIcon color="white" />
        </Mui.IconButton>
      </form>
    );
  }

  function FilePreview() {
    function ImagePreview() {
      return (
        <div className="file slide-bottom-fade photo">
          <div className="file-icon-area">
            <img
              src={file.data}
              style={{ aspectRatio: file.aspectRatio }}
              className="file-icon"
            />
          </div>
          <small className="file-title photo">{file.fileName}</small>
        </div>
      );
    }
    function XLSXPreview() {
      return (
        <div className="file slide-bottom-fade excel">
          <div className="file-icon-area">
            <ExcelIcon className="file-icon excel" />
          </div>
          <small className="file-title excel">{file.fileName}</small>
        </div>
      );
    }
    function PDFPreview() {
      return (
        <div className="file slide-bottom-fade pdf">
          <div className="file-icon-area">
            <PDFIcon className="file-icon pdf" />
          </div>
          <small className="file-title pdf">{file.fileName}</small>
        </div>
      );
    }
    return (
      <div className="file-preview px-2">
        {file.type === "IMAGE" && <ImagePreview />}
        {file.type === "XLSX" && <XLSXPreview />}
        {file.type === "PDF" && <PDFPreview />}
        <Mui.IconButton
          type="button"
          className="remove-attachment-btn mr-1"
          onClick={() => setFile(null)}
        >
          <CloseIcon color="white" />
        </Mui.IconButton>
      </div>
    );
  }

  return (
    <div className="chat">
      <ChatHeader />
      <Mui.Divider />
      <MessagesBox />
      {file && <FilePreview />}
      <Footer />
    </div>
  );
}

function Message({ data, info, handleOpenPreview }) {
  const received = data.sender_id === info.user_id;

  const onlyImageMsg = data.asset_url && !data.content.text;

  const AssetComponent = {
    IMAGE: () => (
      <img
        onClick={() => handleOpenPreview(data.asset_url)}
        src={data.asset_url}
        className="message-img"
      />
    ),
    XLSX: () => (
      <div style={{ width: "100%" }} className="file slide-bottom-fade excel">
        <div className="file-icon-area">
          <ExcelIcon className="file-icon excel" />
        </div>
        <small className="file-title excel">{data.content.fileName}</small>
        <Mui.IconButton
          className="file-download"
          onClick={() =>
            downloadFileFromUrl(data.asset_url, data.content.fileName)
          }
        >
          <DownloadIcon />
        </Mui.IconButton>
      </div>
    ),
    PDF: () => (
      <div style={{ width: "100%" }} className="file slide-bottom-fade pdf">
        <div className="file-icon-area">
          <PDFIcon className="file-icon pdf" />
        </div>
        <small className="file-title pdf">{data.content.fileName}</small>
        <Mui.IconButton
          className="file-download"
          onClick={() =>
            downloadFileFromUrl(data.asset_url, data.content.fileName)
          }
        >
          <DownloadIcon />
        </Mui.IconButton>
      </div>
    ),
  }[data.asset_type];

  return (
    <div className={"message-row " + (received && "received")}>
      <div
        className={
          "chat-message " +
          (received && " received ") +
          (onlyImageMsg && " only-image ") +
          (data.asset_type === "IMAGE" && " has-image ")
        }
      >
        {data?.asset_url && <AssetComponent />}
        <span className="msg-text">
          {data?.content?.text
            ?.split(/(https?:\/\/[^\s]+)/g)
            .map((part, index) => {
              if (/(https?:\/\/[^\s]+)/g.test(part)) {
                return (
                  <a
                    key={index}
                    href={part}
                    target="_blank"
                    className="message-link"
                    rel="noopener noreferrer"
                  >
                    {part}
                  </a>
                );
              }
              return part;
            })}
        </span>
        <span className="date-label">
          {data?.created_at.split(" ")[1].slice(0, 5)}
        </span>
      </div>
    </div>
  );
}

function ChatList({ chats, startChatWith, onSearchInputFocus }) {
  return (
    <div className={"chat-list-container "}>
      <Header />
      <Mui.Divider />
      <SearchBox onSearchInputFocus={onSearchInputFocus} />
      <div className="chats-alert mx-1 mb-2">
        <small>
          Suas mensagens aparecerão aqui. Digite o nome de algum participante
          para iniciar um chat
        </small>
      </div>
      <Chats chats={chats} startChatWith={startChatWith} />
    </div>
  );
}

function Header({}) {
  const { user } = useAuth();

  const { username, avatar } = user;

  return (
    <div className="px-2 chat-list-header">
      <div>
        <Mui.Badge
          color="success"
          variant="dot"
          overlap="circular"
          badgeContent=" "
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          className="online-badge"
        >
          {avatar ? (
            <img src={avatar} className="user-avatar" />
          ) : (
            <PersonIcon />
          )}
        </Mui.Badge>
      </div>
      <h5>Mensagens</h5>
    </div>
  );
}

function SearchBox({ onSearchInputFocus }) {
  return (
    <div className="search-chats-box my-1 mx-1">
      <Mui.TextField
        id="filled-basic"
        placeholder="Buscar participante"
        variant="outlined"
        size="small"
        onFocus={onSearchInputFocus}
        className="search-chats"
        InputProps={{
          startAdornment: (
            <Mui.InputAdornment position="start">
              <SearchIcon />
            </Mui.InputAdornment>
          ),
        }}
      />
    </div>
  );
}

function Chats({ chats = [], startChatWith }) {
  function Chat({ info }) {
    return (
      <Mui.Button
        className={
          "chat-row pt-1 px-1 " + (info.unread_messages > 0 && "unread-chat")
        }
        onClick={() => startChatWith(info)}
        key={info.id}
      >
        <div>
          {info.avatar ? (
            <img className="chat-avatar" src={info.avatar} />
          ) : (
            <div className="chat-avatar">
              <PersonIcon />
            </div>
          )}
        </div>
        <div className="chat-text-info ">
          <div className="chat-header-title">
            <span>{info.username || info.email}</span>
            {info.unread_messages > 0 && (
              <div className="new-messages">Novas mensagens</div>
            )}
          </div>
          <small>{info.last_message?.text || "(nenhuma mensagem)"}</small>
        </div>
      </Mui.Button>
    );
  }
  return (
    <div className="chats">
      {chats?.map((chat, i) => (
        <div key={i}>
          <Chat info={chat} key={i} />
          <Mui.Divider className="mx-1" />
        </div>
      ))}
    </div>
  );
}

async function downloadFileFromUrl(url, filename) {
  console.log(url, filename);
  try {
    var link = document.createElement("a");
    link.download = filename;
    link.href = url;
    link.click();
    link.remove();
  } catch (error) {
    console.error("There was an error downloading the file:", error);
  }
}
